@use "~theme/typographyV2" as typography;
@use "~theme/breakpoints";

.desktopOnly {
  display: none;
  @include breakpoints.tablet {
    display: block;
  }
}

.mobileOnly {
  display: block;
  @include breakpoints.tablet {
    display: none;
  }
}

.order {
  @include breakpoints.tablet {
    display: grid;
    grid-template-columns: 110px 1fr;
    gap: 24px;
    align-items: top;
    padding: 0 20px;
    margin-top: 20px;
  }
}

.desktopOnly,
.mobileOnly {
  min-width: 0;
}

.thumbnail {
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  margin-bottom: 15px;

  @include breakpoints.tablet {
    flex-direction: column;
    gap: 16px;
    justify-content: center;
    align-items: center;
  }
}

.thumbnailIcon {
  height: 30px;

  @include breakpoints.tablet {
    height: 40px;
  }
}

.thumbnailDescription {
  @include typography.body;
  font-family: typography.$font-mont;

  @include breakpoints.tablet {
    font-weight: 700;
    font-style: Bold;
    font-size: 16px;
    line-height: 22.4px;
    letter-spacing: 0.32px;
    text-align: center;
    vertical-align: middle;
    color: var(--pure-black);
  }
}

.data {
  margin-top: 18px;
  display: grid;
  gap: 8px;
  background-color: var(--blue-03);
  padding: 5px;
  border-radius: 20px;

  @include breakpoints.tablet {
    margin: 0;
    border: 1px solid var(--blue-03);
    grid-template-columns: 2fr 2fr 3fr;
    padding: 16px 24px;
  }
}

.itemizedSection {
  grid-column: 1 / -1;
  margin-top: 0;
  margin-bottom: 8px;

  @include breakpoints.tablet {
    margin-top: 12px;
    margin-bottom: 0;
  }
}

.expandButton {
  @include typography.caption-semibold;
  color: var(--blue-01);
  background: transparent;
  border: 0;
  padding: 0;
  cursor: pointer;
  text-decoration: underline;
  text-underline-offset: 2px;
  margin-left: 16px;

  @include breakpoints.tablet {
    margin-left: 0;
  }

  &:hover {
    color: var(--highlight-blue);
  }
}

.itemizedPanel {
  margin-top: 12px;
  border: 1px solid var(--blue-01-at-30);
  border-radius: 12px;
  background-color: var(--white);
  overflow: hidden;
}

.itemTrackingLink {
  @include typography.caption-semibold;
  display: inline-block;
  margin: 12px 16px 0;
  color: var(--blue-01);
  text-decoration: underline;
  text-underline-offset: 2px;

  &:hover {
    color: var(--highlight-blue);
  }
}

.itemizedHeader,
.itemizedRow {
  display: grid;
  grid-template-columns: minmax(0, 2fr) minmax(0, 1fr) minmax(0, 1.5fr);
  gap: 16px;
  padding: 12px 24px 12px 16px;
  align-items: center;
}

.itemizedHeader {
  @include typography.caption-semibold;
  background-color: var(--blue-03);
  color: var(--blue-01);
}

.itemizedList {
  list-style: none;
  margin: 0;
  padding: 0;
}

.itemizedRow {
  @include typography.caption;
  border-top: 1px solid var(--blue-01-at-30);
}

.itemizedHeader span,
.itemizedRow span {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: typography.$font-mont;
}

.itemizedHeader span:nth-child(1),
.itemizedRow span:nth-child(1) {
  white-space: normal; // Item column can wrap
  font-family: typography.$font-mont;
}

.eyeCell {
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

.eyeCell .itemTrackingLink {
  margin: 0;
}

.itemizedHeader span:nth-child(3),
.itemizedRow span:nth-child(3) {
  justify-self: start;
}

.item {
  display: flex;
  justify-content: space-between;

  @include breakpoints.tablet {
    gap: 4px;
    flex-direction: column;
    justify-content: flex-start;
  }
}

.largeItem {
  border: 1px solid var(--blue-03);
  border-radius: 4px 4px 0 0;
  padding: 16px;
  background-color: var(--gray-04-at-30);
  display: flex;
  flex-direction: column;
  gap: 4px;

  @include breakpoints.tablet {
    // Unset all of the "gray area" behavior from mobile
    border-radius: 4px;
    margin: 0;
    border: none;
    padding: 0;
    background-color: unset;
  }
}

.prop {
  font-family: typography.$font-mont;
  font-weight: 700;
  font-style: Bold;
  font-size: 16px;
  line-height: 200%;
  letter-spacing: 0%;
  vertical-align: middle;
  color: var(--pure-black);
}

.value {
  @include typography.body;
}

.byline {
  font-family: typography.$font-mont;
  font-weight: 400;
  font-style: Regular;
  font-size: 14px;
  line-height: 22.4px;
  letter-spacing: 0.32px;
  color: var(--pure-black);

  @include breakpoints.desktop {
    font-size: 16px;
    line-height: 200%;;
  }
}

.promisedDate {
  margin-top: 8px;

  @include typography.caption;
}

.destinationBar {
  background-color: var(--blue-03);
  padding: 10px 12px;
  text-align: center;
  margin: 8px 0 0;
  border-radius: 0 0 4px 4px;
  overflow-wrap: anywhere;
  word-break: break-word;

  @include breakpoints.tablet {
    grid-column: 1 / -1;
    text-align: center;
    padding: 10px 0;
    background-color: var(--blue-03);
    margin: 8px -24px -16px;
    color: var(--blue-01);
  }

  @include typography.caption;
}

.destination {
  @include typography.caption-semibold;

  a {
    overflow-wrap: anywhere;
    word-break: break-word;
  }
}

.logo {
  margin-right: 8px;
  vertical-align: text-top;
}
